import { render, staticRenderFns } from "./roleAssignmentUser.vue?vue&type=template&id=20dfab9f&scoped=true&"
import script from "./roleAssignmentUser.vue?vue&type=script&lang=ts&"
export * from "./roleAssignmentUser.vue?vue&type=script&lang=ts&"
import style0 from "./roleAssignmentUser.vue?vue&type=style&index=0&lang=css&"
import style1 from "./roleAssignmentUser.vue?vue&type=style&index=1&id=20dfab9f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20dfab9f",
  null
  
)

export default component.exports